import { StatusNotificacao } from './status.types';

type NotificacaoStatusVariant = 'brand' | 'neutral' | 'error' | 'warning' | 'success';

interface NotificacaoStatusOption {
  value: StatusNotificacao | null;
  label: string;
  tooltip?: string;
  variant: NotificacaoStatusVariant;
}

export const notificacaoStatusOptions: NotificacaoStatusOption[] = [
  { value: null, label: 'Todos', variant: 'neutral' },
  {
    value: StatusNotificacao.RASCUNHO,
    label: 'Rascunho',
    tooltip: 'Notificação criada, aguardando envio.',
    variant: 'neutral',
  },
  {
    value: StatusNotificacao.AGENDADA,
    label: 'Agendada',
    tooltip: 'Notificação agendada para envio futuro.',
    variant: 'brand',
  },
  {
    value: StatusNotificacao.EM_PROCESSAMENTO,
    label: 'Em processamento',
    tooltip: 'Notificação sendo processada para envio.',
    variant: 'warning',
  },
  {
    value: StatusNotificacao.ENVIADA,
    label: 'Enviada',
    tooltip: 'Notificação enviada, aguardando confirmação de entrega.',
    variant: 'brand',
  },
  {
    value: StatusNotificacao.ENTREGUE,
    label: 'Entregue',
    tooltip: 'Notificação entregue ao destinatário.',
    variant: 'success',
  },
  {
    value: StatusNotificacao.VISUALIZADA,
    label: 'Visualizada',
    tooltip: 'Destinatário abriu o e-mail, WhatsApp ou link.',
    variant: 'success',
  },
  {
    value: StatusNotificacao.EM_NEGOCIACAO,
    label: 'Em negociação',
    tooltip: 'Destinatário iniciou uma negociação.',
    variant: 'brand',
  },
  {
    value: StatusNotificacao.CONCLUIDA,
    label: 'Concluída',
    tooltip: 'Processo de notificação finalizado com sucesso.',
    variant: 'success',
  },
  {
    value: StatusNotificacao.CANCELADA,
    label: 'Cancelada',
    tooltip: 'Notificação cancelada pelo usuário.',
    variant: 'error',
  },
  {
    value: StatusNotificacao.ARQUIVADA,
    label: 'Arquivada',
    tooltip: 'Notificação arquivada.',
    variant: 'neutral',
  },
  {
    value: StatusNotificacao.PARCIALMENTE_ENVIADA,
    label: 'Parcialmente enviada',
    tooltip: 'Alguns canais foram enviados, outros falharam.',
    variant: 'warning',
  },
  {
    value: StatusNotificacao.REENVIADA,
    label: 'Reenviada',
    tooltip: 'Notificação foi reenviada manualmente.',
    variant: 'brand',
  },
  {
    value: StatusNotificacao.PARCIALMENTE_ENTREGUE,
    label: 'Parcialmente entregue',
    tooltip: 'Entregue em pelo menos um canal, mas houve falha em outros.',
    variant: 'warning',
  },
  {
    value: StatusNotificacao.FALHA_ENVIO,
    label: 'Falha no envio',
    tooltip: 'Erro técnico ao tentar disparar a notificação.',
    variant: 'error',
  },
  {
    value: StatusNotificacao.ENVIANDO,
    label: 'Enviando',
    tooltip: 'Notificação em processo de disparo.',
    variant: 'warning',
  },
  {
    value: StatusNotificacao.AGUARDANDO_ENVIO,
    label: 'Aguardando envio',
    tooltip: 'Pronto para ser processado pelo sistema.',
    variant: 'neutral',
  },
];

export const getNotificacaoStatusOption = (
  status: StatusNotificacao | string | null | undefined,
): NotificacaoStatusOption | undefined => {
  if (!status) return undefined;
  return notificacaoStatusOptions.find((opt) => opt.value === status);
};

export const getNotificacaoStatusVariant = (
  status: StatusNotificacao | string | null | undefined,
): NotificacaoStatusVariant => {
  return getNotificacaoStatusOption(status)?.variant ?? 'neutral';
};

export const getNotificacaoStatusTooltip = (
  status: StatusNotificacao | string | null | undefined,
): string | undefined => {
  return getNotificacaoStatusOption(status)?.tooltip;
};
